import { DataTestProps } from "@amzn/stencil-react-components/dist/submodules/utils";
import { Link, LinkTextDecorationOptions } from "@amzn/stencil-react-components/link";
import React from "react";
import { useHistory } from "react-router-dom";

interface InternalLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  target?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  testId?: string;
  textDecoration?: LinkTextDecorationOptions;
}

export const InternalLink: React.FC<InternalLinkProps> = ({
  to,
  children,
  className = "",
  target = "",
  onClick = () => {},
  testId,
  textDecoration = LinkTextDecorationOptions.None,
}) => {
  const history = useHistory();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onClick(e);
    if (target === "_blank") {
      window.open(to, "_blank");
      return;
    }
    history.push(to);
  };

  return (
    <Link
      href={to}
      onClick={handleClick}
      className={className}
      textDecoration={textDecoration ?? LinkTextDecorationOptions.None}
      data-testid={testId}
      style={{ cursor: "pointer" }}
    >
      {children}
    </Link>
  );
};
